import { produce } from 'immer';
import {
  RESET_RULE_FILTERS,
  UPDATE_ACTIVE_FILTERS,
  UPDATE_COUNTRIES_FILTER,
  UPDATE_DATE_OPERATOR,
  UPDATE_DIRECT_REPORTS,
  UPDATE_EMPLOYEE_JOB_LEVEL,
  UPDATE_HIRE_END_DATE,
  UPDATE_HIRE_START_DATE,
  UPDATE_LEADER_LEVEL,
  UPDATE_LEADER_LOGINS,
  UPDATE_MANAGER,
  UPDATE_METRIC_FILTER,
  UPDATE_METRIC_NAME,
  UPDATE_METRIC_OPERATOR,
  UPDATE_METRIC_VALUE,
  UPDATE_RULE_FILTERS,
} from '../actions/ruleFiltersActionTypes';
import { SegmentFilters } from '../constants/createSegment';
import toLocal from '../util/segmentCreation/toLocalDate';

const DEFAULT_ACTIVE_RULES = [
  SegmentFilters.LEADER_FILTER,
  SegmentFilters.METRIC_FILTER,
  SegmentFilters.HIRE_DATE_FILTER,
];
const initialState = {
  leaderJobLevel: 0,
  employeeJobLevels: [],
  isDirectReport: null,
  metrics: [],
  countries: [],
  leaderLogins: [],
  isManager: null,
  lastHireDateInMillis: toLocal(),
  dateOperator: '',
  lastHireEndDateInMillis: toLocal(),
  metricValue: '',
  metricOperator: '',
  metricName: '',
  activeFilters: [...DEFAULT_ACTIVE_RULES],
};

export default function ruleFilters(state = initialState, action) {
  return produce(state, draftState => {
    switch (action.type) {
      /**
       * Set the Rule Filters for Segment creation
       */
      case UPDATE_RULE_FILTERS: {
        const {
          leaderJobLevel,
          employeeJobLevels,
          countries,
          leaderLogins,
          isManager,
          lastHireDateInMillis,
          dateOperator,
          lastHireEndDateInMillis,
          metricValue,
          metricOperator,
          metricName,
        } = action.payload;
        draftState.leaderJobLevel = leaderJobLevel;
        draftState.employeeJobLevels = employeeJobLevels;
        draftState.countries = countries;
        draftState.leaderLogins = leaderLogins;
        draftState.isManager = isManager;
        draftState.lastHireDateInMillis = lastHireDateInMillis;
        draftState.dateOperator = dateOperator;
        draftState.lastHireEndDateInMillis = lastHireEndDateInMillis;
        draftState.metricValue = metricValue;
        draftState.metricOperator = metricOperator;
        draftState.metricName = metricName;

        break;
      }
      case UPDATE_LEADER_LEVEL: {
        draftState.leaderJobLevel = action.payload;
        break;
      }
      case UPDATE_LEADER_LOGINS: {
        draftState.leaderLogins = action.payload;
        break;
      }
      case UPDATE_COUNTRIES_FILTER: {
        draftState.countries = action.payload;
        break;
      }
      case UPDATE_MANAGER: {
        draftState.isManager = action.payload;
        break;
      }
      case UPDATE_EMPLOYEE_JOB_LEVEL: {
        draftState.employeeJobLevels = action.payload;
        break;
      }
      case UPDATE_DATE_OPERATOR: {
        draftState.dateOperator = action.payload;
        break;
      }
      case UPDATE_HIRE_END_DATE: {
        draftState.lastHireEndDateInMillis = action.payload;
        break;
      }
      case UPDATE_HIRE_START_DATE: {
        draftState.lastHireDateInMillis = action.payload;
        break;
      }
      case UPDATE_METRIC_NAME: {
        draftState.metricName = action.payload;
        break;
      }
      case UPDATE_METRIC_OPERATOR: {
        draftState.metricOperator = action.payload;
        break;
      }
      case UPDATE_METRIC_VALUE: {
        draftState.metricValue = action.payload;
        break;
      }
      case UPDATE_ACTIVE_FILTERS: {
        draftState.activeFilters = action.payload;
        break;
      }
      case UPDATE_DIRECT_REPORTS: {
        draftState.isDirectReport = action.payload;
        break;
      }
      case UPDATE_METRIC_FILTER: {
        draftState.metrics = action.payload;
        break;
      }
      case RESET_RULE_FILTERS: {
        draftState.leaderJobLevel = 0;
        draftState.employeeJobLevels = [];
        draftState.leaderLogins = [];
        draftState.countries = [];
        draftState.isManager = null;
        draftState.lastHireDateInMillis = toLocal();
        draftState.dateOperator = '';
        draftState.lastHireEndDateInMillis = toLocal();
        draftState.metricValue = '';
        draftState.metricOperator = '';
        draftState.metricName = '';
        draftState.metrics = [];
        draftState.isDirectReport = null;
        draftState.activeFilters = [...DEFAULT_ACTIVE_RULES];
      }
      default:
        break;
    }
  });
}
